import type { ChannelId } from '@/Enums/ChannelId.enum';
import type DeviceId from '@/Enums/DeviceId.enum';
import type { NeuronMimeTypes } from '@/Enums/Neuron/NeuronMimeTypes.enum';
import type { IAdswizzAudienceTargeting, IAudienceTargeting } from '@/Interfaces/Audiences/Audience.interface';
import type { IDealGroup } from '@/Interfaces/Beeswax/DealGroup.interface';
import type { IImpressionCalculation } from '@/Interfaces/Forecaster';
import type { IFencingLocation, ITargetingLocation } from '@/Interfaces/Location.interface';
import { FORECASTER_PREVIEW_ENDPOINT } from '@/constants/endpoints';
import axios from 'axios';

export type GetForecastForChannelParams = {
  channelId: ChannelId;
  geographic?: ITargetingLocation[];
  geoFence?: IFencingLocation;
  geoExclusion?: ITargetingLocation[];
  audience?: IAudienceTargeting;
  adswizzAudience?: IAdswizzAudienceTargeting;
  productId?: number;
  adswizzProductId?: number;
  beeswaxPublishers?: number[];
  doohPublishers?: string[];
  venueIds?: number[];
  mimeTypes?: NeuronMimeTypes;
  isCustomList: boolean;
  averageCpm?: number;
  isAverageToggled?: boolean;
  daysInRange: number;
  frequencyCapPerDay?: number;
  duration?: number;
  dealGroupIds: IDealGroup['id'][];
  packageId?: number;
  deviceIds: DeviceId[];
};

export const getForecastForChannel = async (body: GetForecastForChannelParams) => {
  const { data } = await axios.post<IImpressionCalculation>(FORECASTER_PREVIEW_ENDPOINT, body);
  return data;
};
